import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fix Leaflet marker icon issue
import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

const defaultIcon = L.icon({
  iconUrl,
  shadowUrl: iconShadow,
  iconAnchor: [12, 41],
});
L.Marker.prototype.options.icon = defaultIcon;

interface DistributorLocation {
  name: string;
  lat: number;
  lng: number;
  count: number;
}

const distributors: DistributorLocation[] = [
  { "name": "Agra", "lat": 27.17667, "lng": 78.00807, "count": 11 },
  { "name": "Ahmedabad", "lat": 23.02579, "lng": 72.58727, "count": 10 },
  { "name": "Aligarh", "lat": 27.8974, "lng": 78.0880, "count": 1 },
  { "name": "Alwar", "lat": 27.5600, "lng": 76.6200, "count": 1 },
  { "name": "Amritsar", "lat": 31.6340, "lng": 74.8723, "count": 1 },
  { "name": "Auriya", "lat": 26.7680, "lng": 79.5180, "count": 1 },
  { "name": "Banaras", "lat": 25.3176, "lng": 82.9739, "count": 2 },
  { "name": "Bareilly", "lat": 28.3670, "lng": 79.4304, "count": 1 },
  { "name": "Bharatpur", "lat": 27.2173, "lng": 77.4890, "count": 1 },
  { "name": "Bhopal", "lat": 23.2599, "lng": 77.4126, "count": 1 },
  { "name": "Bilaspur", "lat": 22.0796, "lng": 82.1391, "count": 1 },
  { "name": "Chandigarh", "lat": 30.7333, "lng": 76.7794, "count": 2 },
  { "name": "Delhi", "lat": 28.65195, "lng": 77.23149, "count": 4 },
  { "name": "Dhaulpur", "lat": 26.7023, "lng": 77.8956, "count": 1 },
  { "name": "Durg", "lat": 21.19045, "lng": 81.28492, "count": 1 },
  { "name": "Ganganagar", "lat": 29.9030, "lng": 73.8774, "count": 2 },
  { "name": "Gorakhpur", "lat": 26.7606, "lng": 83.3732, "count": 1 },
  { "name": "Guna", "lat": 24.6489, "lng": 77.3115, "count": 2 },
  { "name": "Gwalior", "lat": 26.2183, "lng": 78.1828, "count": 2 },
  { "name": "Hisar", "lat": 29.1492, "lng": 75.7217, "count": 1 },
  { "name": "Hoshangabad", "lat": 22.7441, "lng": 77.73697, "count": 1 },
  { "name": "Hupri", "lat": 16.6194, "lng": 74.4009, "count": 1 },
  { "name": "Indore", "lat": 22.7179, "lng": 75.8333, "count": 2 },
  { "name": "Jabalpur", "lat": 23.1815, "lng": 79.9864, "count": 1 },
  { "name": "Jagdalpur", "lat": 19.0740, "lng": 82.0288, "count": 1 },
  { "name": "Kanpur", "lat": 26.4652, "lng": 80.3498, "count": 2 },
  { "name": "Kashganj", "lat": 27.8160, "lng": 78.5694, "count": 1 },
  { "name": "Kota", "lat": 25.2138, "lng": 75.8648, "count": 3 },
  { "name": "Morvi", "lat": 22.8180, "lng": 70.8292, "count": 1 },
  { "name": "Mumbai", "lat": 19.07609, "lng": 72.87743, "count": 1 },
  { "name": "Neemach", "lat": 24.4783, "lng": 74.7800, "count": 1 },
  { "name": "Raisinghnagar", "lat": 29.8750, "lng": 73.5000, "count": 1 },
  { "name": "Rajkot", "lat": 22.3039, "lng": 70.8022, "count": 8 },
  { "name": "Ratlam", "lat": 23.3331, "lng": 75.0340, "count": 1 },
  { "name": "Rourkela", "lat": 22.2249, "lng": 84.8536, "count": 1 },
  { "name": "Sagvara", "lat": 23.6675, "lng": 74.0241, "count": 1 },
  { "name": "Udaipur", "lat": 24.5854, "lng": 73.7125, "count": 5 },
  { "name": "Vadodara", "lat": 22.3072, "lng": 73.1812, "count": 1 }
];

const MapWithDistributors: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row", 
        justifyContent: "center",
        alignItems: "stretch",
        gap: "1.5rem",
        margin: "2rem auto",
        maxWidth: "100rem",
        padding: "1rem",
      }}
    >
      {/* 🗺️ Map Section */}
      <div
        style={{
          flex: "1 1 600px",
          minWidth: "300px",
          height: "75rem",
          
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        }}
      >
        <MapContainer
          center={[27.8, 77.5]}
          zoom={7}
          style={{ width: "100%", height: "100%" }}
        >
          <TileLayer
  url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
  attribution='&copy; <a href="https://carto.com/attributions">CARTO</a>'
/>
          {distributors.map((city, i) => (
            <Marker key={i} position={[city.lat, city.lng]}>
              <Popup>
                <strong>{city.name}</strong>
                <br />
                {city.count} distributors
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>

      {/* 📋 Distributors List Section */}
      <div
        style={{
          flex: "0 1 300px",
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "1.5rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          height: "75rem", 
          overflowY: "scroll"
        }}
      >
        <h2 style={{ marginBottom: "1rem", fontSize: "1.25rem" }}>
          Distributors
        </h2>
        <ul style={{ listStyle: "none", padding: 0 }}>
          {distributors.map((d, i) => (
            <li
              key={i}
              style={{
                marginBottom: "0.75rem",
                display: "flex",
                justifyContent: "space-between",
                fontSize: "1rem",
                borderBottom: "1px solid #eee",
                paddingBottom: "0.5rem",
              }}
            >
              <span>{d.name}</span>
              <strong>{d.count}</strong>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MapWithDistributors;
